import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbAlert } from '@ng-bootstrap/ng-bootstrap';
import { filter, take } from 'rxjs';
import { InputFieldComponent } from 'src/app/components/form/input-field/input-field.component';
import { AlertInfo } from 'src/app/models/alert-info';
import { CompaniesService } from 'src/app/services/api/general-settings/companies.service';
import { MainLayoutService } from 'src/app/services/main-layout.service';

@Component({
  selector: 'app-time-zone',
  imports: [ReactiveFormsModule, InputFieldComponent, NgbAlert],
  templateUrl: './time-zone.component.html',
  styleUrl: './time-zone.component.scss',
})
export class TimeZoneComponent implements OnInit {

  form!: FormGroup;
  alertInfo: AlertInfo = { show: false, type: '', message: '' };

  private companyId!: number;

  constructor(
    private companiesService: CompaniesService,
    private mainLayoutService: MainLayoutService,
  ) {}

  ngOnInit(): void {
    this.loadCompanyData();
  }

  get openingTimeControl(): FormControl {
    return this.form.get('openingTime') as FormControl;
  }

  get closingTimeControl(): FormControl {
    return this.form.get('closingTime') as FormControl;
  }

  cancel(): void {
    this.loadCompanyData();
  }

  save(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    const { openingTime, closingTime } = this.form.getRawValue();
    const payload = {
      companyId: this.companyId,
      tenantId: 1,
      openingTime,
      closingTime,
    };
    this.companiesService.updateWorkingHours(this.companyId, payload).subscribe({
      next: () => {
        this.showAlertInfo('success', 'Settings saved successfully.');
      },
      error: () => {
        this.showAlertInfo('danger', 'An error occurred while saving the settings.');
      },
    });
  }

  private loadCompanyData(): void {
    this.mainLayoutService.company$.pipe(filter((company) => company !== null), take(1)).subscribe((company: any) => {
      console.log('Company data loaded:', company);
      this.companyId = company?.companyId;
      const openingTime = company?.openingTime ?? '';
      const closingTime = company?.closingTime ?? '';
      if (this.form) {
        this.form.reset({ openingTime, closingTime });
      } else {
        this.form = new FormGroup({
          openingTime: new FormControl(openingTime, Validators.required),
          closingTime: new FormControl(closingTime, Validators.required),
        });
      }
    });
  }

  private showAlertInfo(type: string, message: string): void {
    this.alertInfo = { show: true, type, message };
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => { this.alertInfo.show = false; }, 3000);
  }
}
